import { __assign, __rest } from "tslib";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useScrollAware } from '@wix/da-hooks/pkg/useScrollAware';
import StickyContent from './StickyContent';
function getHeight(node) {
    if (!node) {
        return 0;
    }
    return node.getBoundingClientRect().height;
}
var Sticky = function (_a) {
    var zIndex = _a.zIndex, _b = _a.marginTop, marginTop = _b === void 0 ? 0 : _b, _c = _a.marginLeft, marginLeftProp = _c === void 0 ? 0 : _c, _d = _a.bottomStop, bottomStop = _d === void 0 ? 0 : _d, usePortal = _a.usePortal, _e = _a.stickTo, stickTo = _e === void 0 ? 'top' : _e, customCheckIfStuck = _a.customCheckIfStuck, onStuckChange = _a.onStuckChange, contentProps = __rest(_a, ["zIndex", "marginTop", "marginLeft", "bottomStop", "usePortal", "stickTo", "customCheckIfStuck", "onStuckChange"]);
    var rootRef = useRef(null);
    var innerRef = useRef(null);
    var mounted = useRef(false);
    var _f = useState(getHeight(innerRef.current)), minHeight = _f[0], setMinHeight = _f[1];
    var _g = useState(typeof marginLeftProp === 'number' ? marginLeftProp : 0), marginLeft = _g[0], setMarginLeft = _g[1];
    var _h = useState({
        zIndex: zIndex,
        marginTop: marginTop,
    }), style = _h[0], setStyle = _h[1];
    var checkIfStuck = useCallback(function () {
        if (!rootRef.current) {
            return false;
        }
        var rootRect = rootRef.current.getBoundingClientRect();
        return customCheckIfStuck
            ? customCheckIfStuck(rootRect)
            : rootRect.top - marginTop <= 0;
    }, [marginTop, customCheckIfStuck]);
    var _j = useState(checkIfStuck()), isStuck = _j[0], setIsStuck = _j[1];
    var updatePosition = useCallback(function (_a) {
        var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        var isStuckNow = checkIfStuck();
        setIsStuck(isStuckNow);
        var height = minHeight || getHeight(innerRef.current);
        setMinHeight(height);
        // If we're sticking, calculate the vertical position depending on the value of `stickTo` and `stop`
        var position = 0;
        if (!isStuckNow) {
            return;
        }
        else if (bottomStop !== 0) {
            var diff = scrollHeight - scrollTop - height - marginTop - bottomStop;
            position = diff < 0 ? diff : 0;
        }
        setStyle({
            zIndex: zIndex,
            marginTop: marginTop,
            top: stickTo === 'top' ? position : 'auto',
            bottom: stickTo === 'bottom' ? position : 'auto',
        });
    }, [checkIfStuck, minHeight, bottomStop, zIndex, marginTop, stickTo]);
    useScrollAware(updatePosition);
    useEffect(function () {
        if (marginLeftProp === 'preserve') {
            var clientRectLeft = innerRef.current.getBoundingClientRect().left;
            setMarginLeft(clientRectLeft);
        }
    }, [marginLeftProp]);
    // If the checking function changes refresh the state, in case we're not stuck anymore
    // e.g. when `isStuck` value depends on some external value that is evaluated by `customCheckIfStuck`
    useEffect(function () { return setIsStuck(checkIfStuck()); }, [checkIfStuck]);
    useEffect(function () {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        onStuckChange && onStuckChange(isStuck);
    }, [isStuck, onStuckChange]);
    var content = (React.createElement(StickyContent, __assign({ isStuck: isStuck, style: __assign(__assign({}, style), { marginLeft: marginLeft }), ref: innerRef }, contentProps)));
    return (React.createElement("div", { ref: rootRef, style: { minHeight: minHeight } }, usePortal && isStuck
        ? ReactDOM.createPortal(content, document.body)
        : content));
};
Sticky.displayName = 'Sticky';
export default Sticky;
//# sourceMappingURL=Sticky.js.map